import { render, staticRenderFns } from "./PopupQuotaLimit.vue?vue&type=template&id=16692e2c&scoped=true&"
import script from "./PopupQuotaLimit.vue?vue&type=script&lang=js&"
export * from "./PopupQuotaLimit.vue?vue&type=script&lang=js&"
import style0 from "./PopupQuotaLimit.vue?vue&type=style&index=0&id=16692e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16692e2c",
  null
  
)

export default component.exports